import LocalizedStrings from 'localized-strings';

import { TeamMembersRequestType } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    subtitle: 'For {name}',
    subtitleWithDate: 'For {name} · {date}',
    type: {
      [TeamMembersRequestType.VirtualPaymentCardOrder]: {
        name: 'Virtual card',
      },
      [TeamMembersRequestType.VirtualBudgetCardOrder]: {
        name: 'Virtual budget card',
      },
      [TeamMembersRequestType.PhysicalPaymentCardOrder]: {
        name: 'Physical card',
      },
      [TeamMembersRequestType.BankTransfer]: {
        name: 'Bank transfer',
      },
      [TeamMembersRequestType.ExpenseClaim]: {
        name: 'Expense claim',
      },
    },
  },
  fr: {
    subtitle: 'Par {name}',
    subtitleWithDate: 'Par {name} · {date}',
    type: {
      [TeamMembersRequestType.VirtualPaymentCardOrder]: {
        name: 'Carte virtuelle',
      },
      [TeamMembersRequestType.VirtualBudgetCardOrder]: {
        name: 'Carte virtuelle à budget',
      },
      [TeamMembersRequestType.PhysicalPaymentCardOrder]: {
        name: 'Carte physique',
      },
      [TeamMembersRequestType.BankTransfer]: {
        name: 'Virement bancaire',
      },
      [TeamMembersRequestType.ExpenseClaim]: {
        name: 'Note de frais',
      },
    },
  },
} as const);

export default locales;
